<template>
  <slot />
</template>

<script setup lang="ts">
import {
  ConfigService,
  FaroObservabilityService,
  MixpanelAnalyticsService,
  useGlobalDependencyProvider,
  UserService,
} from '@teachino/shared-util';
import { RouterService, type Route, RouterHistory } from '@teachino/shared-router'
import { TenantManagementType } from '../graphql';
import  {
} from '@teachino/library-domain';
import { useLibraryProvider } from '@teachino/library-domain';
import { getUserLanguage } from '@teachino/shared-i18n';
import { Settings } from 'luxon';
import { navigateTo } from 'nuxt/app'
import { productFruits } from 'product-fruits';


const { getMeRef } = useCurrentUser();

console.info('Providing Dependencies...');
const me = getMeRef().value;
const di = useGlobalDependencyProvider();


const config = new ConfigService()
di.provide('config', config)

import { useAuth } from "@teachino/shared-auth";
const auth = useAuth();

const navigate = async (route: Pick<Route, 'path' | 'query'> | string):Promise<void> => {
  try {

    if(window.self !== window.top) {
      const routePath = typeof route ===  'string' ? route : route.path;
      const searchString = route.query ? new URLSearchParams(route.query).toString() : ''
      const routeString = encodeURIComponent(`${routePath}?${searchString}`);
      const refreshToken = auth.getRefreshToken();
      window.open(`/auth/refresh?refreshToken=${refreshToken}&redirect=${routeString}&${searchString}`, '_blank');
      return;
    }
    if(typeof route === 'string'){
      await navigateTo({
        route,
      })
    } else {
      await navigateTo({
        path: route.path,
        query: route.query,
      })
    }
  } catch(e: unknown)  {
    console.error(e)
    console.error('failed to navigate')
  }
  return
}
const history = new RouterHistory(navigate)

const router = new RouterService(history)
di.provide('router', router)

const faroObservabilityService = new FaroObservabilityService()

const analytics = new MixpanelAnalyticsService()
di.provide('analytics', analytics);


if (me) {
  Settings.defaultLocale = getUserLanguage()

  const tenantIds = me.myTenants
    .filter((tenant) => tenant.managementType === TenantManagementType.Managed)
    .map((tenant) => (tenant.parent ? tenant.parent.id : tenant.id));

  faroObservabilityService.setUser(me.me.id)
  config.setLegacyMeRef(me)
  di.provide('faro', faroObservabilityService);

  if (me.currentLicense?.plan?.features.find((feature) => feature.key === 'analytics')) {
    let shouldRecord = false;
    try {
      const createdAt = me.me.createdAt;
      const createdDate = new Date(createdAt);
      const analyticsEnableDate = new Date('2025-11-01T00:00:00Z');
      shouldRecord = createdDate >= analyticsEnableDate;
      //disable recording for now
      shouldRecord = false;
    } catch (e) {
      console.error(e);
    }
    analytics.init(me.me.id, tenantIds, me.currentLicense?.plan?.key, shouldRecord);

    productFruits.init('HKQYzcQtZFBlWgh2', me.me.language, { username: me.me.id });
  } else {
    analytics.doNotTrack();
  }




  const user = new UserService(me);
  di.provide('user', user);

  if (!window.sleekplan_initialised) {
    //initialise sleekplan for customer support and feedback
    window.sleekplan_initialised = true;
    window.$sleek = [];
    window.SLEEK_USER = {
      token: me.supportToken.token,
    };
    window.SLEEK_PRODUCT_ID = config.sleekplanProductId();
    (function () {
      const d = document;
      const s = d.createElement('script');
      s.src = config.sleekplanBaseUrl() + '/sdk/e.js';
      s.async = 1;
      d.getElementsByTagName('head')[0].appendChild(s);
    })();
  }

  const libraryProvider = useLibraryProvider();
  libraryProvider.configure();





}
</script>
